enum AccountFeatures {
  WhiteLabeling = 'whiteLabeling'
}

export default AccountFeatures;
